import { createFileRoute } from '@tanstack/react-router';

import { Box } from '@mantine/core';

import { useLegalEntityContext } from '@/context/LegalEntityContext';
import { QuoteConfigPanel } from '@/features/legal-entities/components/QuoteConfigPanel';
import { buildHead } from '@/utils/html';

export const Route = createFileRoute('/_authenticated/company/quote')({
  component: CompanyQuotePage,
  head: () => buildHead('quote'),
});

function CompanyQuotePage() {
  const { activeEntity } = useLegalEntityContext();

  if (!activeEntity) return null;

  return (
    <Box px='xl' py='lg'>
      <QuoteConfigPanel entityId={activeEntity.id} />
    </Box>
  );
}
